import { CouncilRegion } from 'shared-components';
import useHash from '../../Hooks/UseHash';
import { FoodLicenseWithDocuments } from '../../Services/InsuranceLicenseService';
import InsuranceDocumentLinks from './InsuranceDocumentLinks';
import { formatUnixDate } from './InsuranceLicenseUtils';
import FoodLicenseMobileList from './FoodLicenseMobileList';

type Props = {
	licenses: FoodLicenseWithDocuments[];
	councilRegions: CouncilRegion[];
	nowUnix: number;
	removingLicenseId: number | null;
	onRemoveLicense: (licenseId: number) => void;
};

export default function FoodLicenseTable(props: Props) {
	const { licenses, councilRegions, nowUnix, removingLicenseId, onRemoveLicense } = props;
	const hash = useHash();

	return (
		<div className="food-license-table-region">
			<div className="insurance-license-desktop-table">
				<table className="table table-striped">
					<thead>
						<tr>
							<th className="d-mobile-none">License type</th>
							<th>Council region</th>
							<th className="d-mobile-none">License number</th>
							<th>Expiry</th>
							<th className="d-mobile-none">Documents</th>
							<th className="d-mobile-none"></th>
							<th className="d-mobile-none"></th>
						</tr>
					</thead>
					<tbody>
						{licenses.map((license) => {
							const council = councilRegions.find(
								(region) => region.CouncilRegionId === Number(license.FoodLicenseCouncilRegionId ?? 0),
							);
							const isExpired = Number(license.FoodLicenseExpiry ?? 0) <= nowUnix;
							return (
								<tr key={license.FoodLicenseId}>
									<td className="d-mobile-none">{license.FoodLicenseType || '-'}</td>
									<td className="truncate-characters-30">
										{council?.CouncilRegionName ?? 'Unknown'}
									</td>
									<td className="d-mobile-none">{license.FoodLicenseNumber || '-'}</td>
									<td>{formatUnixDate(license.FoodLicenseExpiry)}</td>
									<td className="d-mobile-none">
										<InsuranceDocumentLinks documents={license.Documents} hash={hash} />
									</td>
									<td className="d-mobile-none">
										{isExpired ? <span className="warning-tag">expired</span> : null}
									</td>
									<td className="d-mobile-none">
										<button
											type="button"
											className="insurance-license-action-link"
											disabled={removingLicenseId === license.FoodLicenseId}
											onClick={() => onRemoveLicense(license.FoodLicenseId)}
										>
											{removingLicenseId === license.FoodLicenseId ? 'Removing...' : 'Remove'}
										</button>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>

			<div className="insurance-license-mobile-only">
				<FoodLicenseMobileList
					licenses={licenses}
					councilRegions={councilRegions}
					nowUnix={nowUnix}
					removingLicenseId={removingLicenseId}
					onRemoveLicense={onRemoveLicense}
				/>
			</div>
		</div>
	);
}
